import { Shark, Utils } from "shark-mvc";

import SiteInfoSheetEditViewBase from "./SiteInfoSheetEditViewBase";

import templateContent from "./site-info-sheet-display.html";

//Dave: Presumo che queste dovrebbero stare altrove
import "../../images/icons/doc.png";
import "../../images/icons/docx.png";
import "../../images/icons/pdf.png";

import contactDetailsModalComponent from "../../components/contactDetailsModal/contactDetailsModalComponent";
import { exportPDFComponent } from "../../_shark_components/exportPDF/exportPDFComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import printButtonComponent from "../../_shark_components/printButton/printButtonComponent";
import siteInfoSheetEditView from "./siteInfoSheetEditView";
import siteInfoSheetListView from "./siteInfoSheetListView";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class SiteInfoSheetDisplayView extends SiteInfoSheetEditViewBase {
	constructor () {
		super("siteInfoSheetDisplayView");
		this.setTemplate(templateContent);
	}

	//Dave: mi sa che non viene gestito
	afterLoad () {
		const currSiteInfoSheet = Shark.get("currSiteInfoSheet");

		if (!currSiteInfoSheet) {
			Shark.openPage(siteInfoSheetListView);
		}
	}

	backToListBtn_clickHandler () {
		this.set("cancelEditsDestination", "siteInfoSheetListView");
		this.cancelEdits();
	}

	beforeLoad () {
		this.beforeLoadCommon("industrial");
	}

	editBtn_clickHandler () {
		Shark.set({
			isEditingSiteInfoSheet: true,
		});
		Shark.openPage(siteInfoSheetEditView);
	}

	init () {
		this.addComponents([contactDetailsModalComponent, exportPDFComponent, mainNavComponent, printButtonComponent, waitBoxComponent]);

		Shark.set({
			applicatorTeamList: Shark.get("applicatorTeamList") || [],
		});

		this.set({
			__htmlTitle: "Scheda Informativa | IPM HUB"
		});
	}
}

const siteInfoSheetDisplayView = new SiteInfoSheetDisplayView();

Shark.registerView(siteInfoSheetDisplayView);

export default siteInfoSheetDisplayView;
